export var ELocalStorageKeys;
(function (ELocalStorageKeys) {
    ELocalStorageKeys["AccessToken"] = "access_token";
    ELocalStorageKeys["IsRHAbove"] = "isRH_above";
    ELocalStorageKeys["LoginType"] = "loginType";
    ELocalStorageKeys["PartnerCategory"] = "partnerCategory";
    ELocalStorageKeys["CadCam"] = "cadCam";
    ELocalStorageKeys["LeaddashFilterdata"] = "leaddashFilterdata";
    ELocalStorageKeys["RefreshPage"] = "refreshPage";
    ELocalStorageKeys["InScope"] = "inScope";
})(ELocalStorageKeys || (ELocalStorageKeys = {}));
